import { Flowchart } from './flowchart';
import { ConceptMap } from './concept-map';
import { ComparisonTable } from './comparison-table';
import { CycleDiagram } from './cycle-diagram';
import { Timeline } from './timeline';
import { Hierarchy } from './hierarchy';
import { TextCard } from './text-card';
import { Graph } from './graph';
import { HtmlRenderer } from './html-renderer';
import { SvgRenderer } from './svg-renderer';

/**
 * Registry maps json-render catalog component types to React components.
 * Used by the Renderer to render the AI-generated JSON tree.
 */
export const visualizationRegistry = {
  Flowchart,
  ConceptMap,
  ComparisonTable,
  CycleDiagram,
  Timeline,
  Hierarchy,
  TextCard,
  Graph,
  HtmlRenderer,
  SvgRenderer,
};

export type VisualizationType = keyof typeof visualizationRegistry;

// Re-export individual components
export { Flowchart } from './flowchart';
export { ConceptMap } from './concept-map';
export { ComparisonTable } from './comparison-table';
export { CycleDiagram } from './cycle-diagram';
export { Timeline } from './timeline';
export { Hierarchy } from './hierarchy';
export { TextCard } from './text-card';
export { Graph } from './graph';
export { HtmlRenderer } from './html-renderer';
export { SvgRenderer } from './svg-renderer';
